import lieferantenSearchData from '@/shared/model/smallPayloadModels/lieferantenSearchData';
import { TblLieferantenState } from './types';

export const state = (): TblLieferantenState => initialState();

export const initialState = (): TblLieferantenState => ({
  isLoadingExcelReport: false,
  lieferantenSearchData: lieferantenSearchData.defaultData(),
  tblLieferantens: {
    //TODO remove when was made backend
    items: [],
    isLoading: undefined,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ['name'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [],
      andClauseFieldsIds: [],
    },
  },
});
